import { Row, Col } from "antd";
import {useSelector} from "react-redux";
import instagram from "../../../../assets/images/instagram.png";
import facebook from "../../../../assets/images/facebook.png";
import twitter from "../../../../assets/images/twitter.png";
import youtube from "../../../../assets/images/youtube.png";
import soundcloud from "../../../../assets/images/soundcloud.png";
import AppleMusic from "../../../../assets/images/applemusic";
import Spotify from "../../../../assets/images/spotify";
import styles from "./style.module.scss";

const Links = () => {
  const { user } = useSelector((state) => ({
    user: state.users.user,
  }));
  return (
    <Row className={styles.linksContainer} justify="space-between" align="top">
      <Col span={11}>
        <h2>Social</h2>
        {user.instagram &&
        <div className={styles.item}>
          <div className={styles.logo}>
            <img src={instagram} alt="instagram" />
          </div>
          <a onClick={()=> window.open(user.instagram, "_blank")} className={styles.link}>{user.instagram}</a>
        </div>}
        {user.facebook &&
        <div className={styles.item}>
          <div className={styles.logo}>
            <img src={facebook} alt="facebook" />
          </div>
          <a onClick={()=> window.open(user.facebook, "_blank")} className={styles.link}>{user.facebook}</a>
        </div>}
        {user.twitter &&
        <div className={styles.item}>
          <div className={styles.logo}>
            <img src={twitter} alt="twitter" />
          </div>
          <a onClick={()=> window.open(user.twitter, "_blank")} className={styles.link}>{user.twitter}</a>
        </div>}
        {user.triller &&
        <div className={styles.item}>
          <div className={styles.logo} />
          <a onClick={()=> window.open(user.triller, "_blank")} className={styles.link}>{user.triller}</a>
        </div>}
        {user.snapchat &&
        <div className={styles.item}>
          <div className={styles.logo} />
          <a onClick={()=> window.open(user.snapchat, "_blank")} className={styles.link}>{user.snapchat}</a>
        </div>}
      </Col>
      <Col span={11}>
        <h2>Music</h2>
        {user.spotify &&
        <div className={styles.item}>
        <div className={styles.logo}>
          <Spotify />
        </div>
          <a onClick={()=> window.open(user.spotify, "_blank")} className={styles.link}>{user.spotify}</a>
        </div>}
        {user.applemusic &&
        <div className={styles.item}>
        <div className={styles.logo} style={{ paddingTop: 3 }}>
          <AppleMusic />
        </div>
          <a onClick={()=> window.open(user.applemusic, "_blank")} className={styles.link}>{user.applemusic}</a>
        </div>}
        {user.youtube && <div className={styles.item}>
        <img
          src={youtube}
          alt="soundcloud"
          style={{ width: 41, height: 41 }}
        />
          <a onClick={()=> window.open(user.youtube, "_blank")} className={styles.link}>{user.youtube}</a>
        </div>}

        {user.soundcloud &&
          <div className={styles.item}>
          <div className={styles.logo}>
            <img
              src={soundcloud}
              alt="soundcloud"
              style={{ width: 41, height: 41 }}
            />
          </div>
            <a onClick={()=> window.open(user.soundcloud, "_blank")} className={styles.link}>{user.soundcloud}</a>
          </div>}

      </Col>
    </Row>
  );
};

export default Links;
